// strings/fullscreen.ts (full screen button, 2026-10-18) — the rotate card a phone held upright sees after Play now (client
// ui/rotate.tsx), the Full screen button (ui/fullscreen.tsx: on the rotate card, top right before a town, and in the in-town Menu) and
// the short guide it opens on an iPhone, whose only full screen is the home-screen app (Share, then Add to Home Screen, then its icon).
import type { StringBank } from '../schema/strings';

export default {
  button: 'Full screen',
  exit: 'Exit full screen',
  rotateTitle: 'Turn your phone sideways to play',
  rotateBody: '{app} plays in landscape, with a thumb on each side.',
  back: 'Back',
  guideTitle: 'Play full screen',
  guideLead: 'On an iPhone, {app} plays full screen from your home screen. Three taps:',
  shareTitle: 'Tap Share',
  shareBody: 'In Safari’s toolbar. On newer iPhones it can sit under the ••• button.',
  addTitle: 'Tap Add to Home Screen',
  addBody: 'Scroll down the list if you don’t see it.',
  openTitle: 'Open {app} from its new icon',
  openBody: 'It opens full screen, with no browser bars.',
  done: 'Got it',
} as const satisfies StringBank;
